import { render, staticRenderFns } from "./SetOfCriteriaTypeSave.vue?vue&type=template&id=4e5c2dcd&"
import script from "./SetOfCriteriaTypeSave.vue?vue&type=script&lang=js&"
export * from "./SetOfCriteriaTypeSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports